/**
 * Whether a task the line made has settled, on the same truth ladder the
 * crown's receipt and the composer's dots read (useTaskLiveStatus). The
 * Dock's settle watch dispatches task_settled off it so the run mark in the
 * glass leaves when the task's dot does (spec 2026-09-12 §6, §9).
 */
import { isSettled, useTaskLiveStatus } from "./useTaskLiveStatus";

/** True once the task has settled on the same truth ladder the inline card
 *  and the dots read (done, stopped, out of credits, failed). False for no task. */
export function useTaskSettled(taskId: string | null): boolean {
  const status = useTaskLiveStatus(taskId);
  return taskId !== null && isSettled(status);
}
